import Vue from 'vue'
import Router from 'vue-router'

import initial from '@/routerlist/init.js'
import adminMenu from '@/routerlist/admin.js'
import channelAirlines from '@/routerlist/channelAirlines.js'
import channelBillboard from '@/routerlist/channelBillboard.js'
import channelBus from '@/routerlist/channelBus.js'
import channelDigital from '@/routerlist/channelDigital.js'
import channelDigitalScreen from '@/routerlist/channelDigitalScreen.js'
import channelExperienceBranding from '@/routerlist/channelExperienceBranding.js'
import channelSPBU from '@/routerlist/channelSPBU.js'
import collections from '@/routerlist/collections.js'
import dashboard from '@/routerlist/dashboard.js'
import defaultPage from '@/routerlist/defaultPage.js'
import documentationMenu from '@/routerlist/documentations.js'
import draft from '@/routerlist/draft.js'
import saved from '@/routerlist/saved.js'
import search from '@/routerlist/search.js'
import campaign from '@/routerlist/campaign.js'
import billboardMap from '@/routerlist/billboardMap.js'
import sovMap from '@/routerlist/sovMap.js'
import mediaOwnerDashboard from '@/routerlist/mediaOwnerDashboard.js'
import utility from "@/routerlist/utility.js";

import store from '@/store'

const notFound = [
  {
    path: '*',
    redirect: '/404'
  }
]

Vue.use(Router)

const mainrouter = new Router({
  mode: 'history',
  routes: [
    ...initial,
    ...adminMenu,
    ...channelAirlines,
    ...channelBillboard,
    ...channelBus,
    ...channelDigital,
    ...channelDigitalScreen,
    ...channelExperienceBranding,
    ...channelSPBU,
    ...collections,
    ...dashboard,
    ...defaultPage,
    ...documentationMenu,
    ...draft,
    ...saved,
    ...search,
    ...campaign,
    ...notFound,
    ...billboardMap,
    ...sovMap,
    ...mediaOwnerDashboard,
    ...utility
  ],
  scrollBehavior (to, from, savedPosition) {
    const { name } = to
    if(name == 'routes' || name == 'vehicle' || name == 'coverage' || 'campaignreportv2-location' || 'campaignreportv2-gender' || 'campaignreportv2-age' ) {
      return
    }
    return { x: 0, y: 0 }
  }
})

mainrouter.beforeEach((to, from, next) => {
  const token = store.getters.token
  const superuser = store.getters.isSuperuser
  const staff = store.getters.isStaff
  const groups = store.getters.groups.split(',')
  if (to.matched.some(record => record.meta.isLogin)) {
    if (token) {
      next({name: 'home'})
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.isStaffAirlines)) {
    if (token  && (superuser || staff)) {
      next()
    } else {
      next({ name: 'comingsoon' })
    }
  } else if (to.matched.some(record => record.meta.isStaffExBranding)) {
    if (token  && (superuser || staff)) {
      next()
    } else {
      next({ path: '/channel/experience' })
    }
  } else if (to.matched.some(record => record.meta.isStaffV34)) {
    if (token  && (superuser || staff)) {
      next()
    } else {
      if (to.name == 'category'){
        if (to.params.name == 'lifestyle'){
          next({ path: '/lifestyle' })
        } else if (to.params.name == 'spbu') {
          next({ path: '/spbu' })
        } else if (to.params.name == 'malls') {
          next({ path: '/malls' })
        } else if (to.params.name == 'airport'){
          next({ path: '/airport' })
        } else {
          next({name: 'home'})
        }
      }
    }
  } else if (to.matched.some(record => record.meta.isAdminChannel)) {
    const hasAdminChannelPermission = groups.includes('admin_channel')
    if (token && (superuser || hasAdminChannelPermission)) {
      next()
    } else {
      next({ name: '403' })
    }
  } else if (to.matched.some(record => record.meta.isDigitalAdmin)) {
    if (token  && (superuser || staff)) {
      next()
    } else {
      next({ name: 'digitalscreenv1' })
    }
  } else if (to.matched.some(record => record.meta.isSuperuser)) {
    if (token && superuser) {
      next()
    } else {
      next({name: 'home'})
    }
  } else if (to.matched.some(record => record.meta.isStaff)) {
    if (token && (superuser || staff)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isCollectionAdmin)) {
    const hasCollectionPermission = groups.includes('Admin Collection')
    if (token && (superuser || hasCollectionPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isGrazilla)) {
    const hasGrazillaPermission = groups.includes('grazilla')
    if (token && (superuser || hasGrazillaPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isPertamina)) {
    const hasPertaminaPermission = groups.includes('Pertamina')
    if (token && (superuser || hasPertaminaPermission)) {
      next()
    } else {
      next({ name: 'signin', query: { next: 'pertamina' } })
    }
  } else if (to.matched.some(record => record.meta.isAdminBus)) {
    const hasAdminBusPermission = groups.includes('admin_bus')
    if (token && (superuser || hasAdminBusPermission)) {
      next()
    } else {
      next({ name: 'signin', query: { next: 'orderexecution' } })
    }
  } else if (to.matched.some(record => record.meta.isUserManager)) {
    const hasUserManagerPermission = groups.includes('user_manager')
    if (token && (superuser || hasUserManagerPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isGA)) {
    const hasGAPermission = groups.includes('GA')
    if (token && (superuser || hasGAPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isOpsSpv)) {
    const hasOpsSpvPermisson = groups.includes('OpsSupervisor')
    if (token && (superuser || hasOpsSpvPermisson)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isOpsSpvOrGA)) {
    const hasOpsSpvPermisson = groups.includes('OpsSupervisor')
    const hasGAPermission = groups.includes('GA')
    if (token && (superuser || hasOpsSpvPermisson || hasGAPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isLinkAja)) {
    const hasLinkAjaPermisson = groups.includes('linkaja')
    if (token && (superuser || hasLinkAjaPermisson || staff)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isMediaOwner)) {
    const hasMediaOwnerPermisson = groups.includes('media_owner')
    if (token && (superuser || hasMediaOwnerPermisson || staff)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({name: 'signin', query: {next: to.path}})
    } else {
      next()
    }
  } else {
    next()
  }
});

export default mainrouter;
